import {getIsProductionAppEnv} from '../../../utils/environment'

/**
 * Unified logic for determining if brand/theme overrides should be allowed.
 * Overrides are only allowed in non-production environments.
 * @param environment - The current application environment
 * @returns boolean - Whether overrides should be allowed
 */
export const shouldAllowOverrides = (environment: string): boolean =>
  !getIsProductionAppEnv(environment)
